import { render } from "./Edit.vue?vue&type=template&id=6d1e12c0"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"

import "./Edit.vue?vue&type=style&index=0&id=6d1e12c0&lang=css"

import exportComponent from "/var/www/vhosts/elyosdigital.com/_build/workspace/MySchool/myschool.elyosdigital.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/teacher/Edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6d1e12c0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6d1e12c0', __exports__)) {
    console.log('reload')
    api.reload('6d1e12c0', __exports__)
  }
  
  module.hot.accept("./Edit.vue?vue&type=template&id=6d1e12c0", () => {
    console.log('re-render')
    api.rerender('6d1e12c0', render)
  })

}


export default __exports__